import React from "react";
import "./style.scss";
import { ToTimeJalali } from "../../../Utils/functions";
import AkoModal from "../../Modal";
import { useState } from "react";

const NoticeCard = ({ data }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <div
        className="notice-card pointer"
        onClick={() => {
          setShow(true);
        }}
      >
        <p className="fs-11 fw-600 lh-19 text-main">{data.title}</p>
        <p className="num fs-10 fw-600 lh-24 text-sub">
          {ToTimeJalali(data.created_at)}
        </p>
      </div>
      <AkoModal
        open={show}
        onClose={() => {
          setShow(false);
        }}
      >
        <p
          className="fs-15 fw-600 lh-19 text-main"
          style={{ marginBottom: "10px" }}
        >
          {data.title}
        </p>
        <div
          dangerouslySetInnerHTML={{ __html: data.content }}
          className="fs-13 fw-500 lh-19 text-main"
        />
      </AkoModal>
    </>
  );
};

export default NoticeCard;
